// extracted by mini-css-extract-plugin
export default {"about_hero":"about_about_hero__XXCX7","hero_desc":"about_hero_desc__j0O8J"};